import bridge from '@utiles/officialStore/bridge';
import globalConfig from '@utiles/officialStore/globalConfig';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';
export default {
  methods: {
    jpService(params) {
      let isAndroid = globalConfig.getHrefParam('devicePlate') === 'android';
      let sdkVersion = +globalConfig.getHrefParam('sdkVersion');
      let searchParams = new URLSearchParams(window.location.search);
      searchParams.set(
        'gameId',
        params ? params.gameId : this.$store.state.gameId
      );
      searchParams.set(
        'serverId',
        params ? params.pcServerId : this.$store.state.pcServerId
      );
      searchParams.set(
        'roleId',
        params ? params.roleId : this.$store.state.roleId
      );
      searchParams.set(
        'roleName',
        params ? params.roleName : this.$store.state.roleName
      );
      searchParams.set(
        'userName',
        params ? params.uid : this.$store.state.login.uid
      );
      let orderLink = getGlobalGetGotoLink({
        link: `https://jpabres.${window.atob('MzdnYW1lcy5jb20=')}/html/support.html?${searchParams.toString()}#/orderlist`
      });
      if (isAndroid && sdkVersion >= 40) {
        bridge.callSdkMethod('openBrowser', {
          url: orderLink,
          loginDir: 1,
          appendParams: 0
        });
      } else {
        window.open(orderLink, '_blank');
      }
    }
  }
};
